document.addEventListener("DOMContentLoaded", function () {
    let widgetRecharge = document.querySelector(".shopify-block.shopify-app-block.recharge-subscription-widget");
    if (!widgetRecharge) {
        return;
    }
    function mutationObserverWidget(){
        const plans = widgetRecharge.querySelector(".rc-selling-plans");
        const subsOtpContent = widgetRecharge.querySelector(".rc-template__radio-group");
        const optionSubs = widgetRecharge.querySelector(".rc-radio.subscription-radio");
        const optionSelect = document.querySelector(".rc-selling-plans-dropdown__select");
        const optionSelectSubs = document.querySelector(".rc-selling-plans-dropdown__select option");
        const changeEvent = new Event('change', { bubbles: true });
    
        if (optionSubs) {
            const inputRadio = optionSubs.querySelector("input.rc-radio__input");
            if (inputRadio) {
                inputRadio.checked = true;
                inputRadio.dispatchEvent(changeEvent);
            }
        }

        if (optionSelect && optionSelectSubs) {
            optionSelect.value = optionSelectSubs.value;
            optionSelect.dispatchEvent(changeEvent);
        }
        
        if (plans && subsOtpContent) {
            widgetRechargeVariant(widgetRecharge);
            observerRecharge.disconnect();
        }
    }
    const observerRecharge = new MutationObserver(mutationObserverWidget);
    
    document.addEventListener("intelligems:loaded", ()=> {
        let testSubsOtpPdp = window.testSubsOtpPdp || "orginial-test-variant"; 
        let isTestSubsOtpPdp =  testSubsOtpPdp  === "subscription-otp-widget-test";

        if(isTestSubsOtpPdp) {
            mutationObserverWidget();
            observerRecharge.observe(widgetRecharge, {
                childList: true,
                subtree: true 
            });
        }
    });
}); 
function widgetRechargeVariant(widgetRecharge) {
    const labelSubs = widgetRecharge.querySelector("label.subscription-radio");
    const contentOtpSubs = widgetRecharge.querySelector(".rc-radio-group__options");
    const sbsDiscountLabel = widgetRecharge.querySelector('.subscription-radio .discount-label');
    const tooltipSubsDetails = widgetRecharge.querySelector('div.rc-tooltip');
    const button = widgetRecharge.querySelector('button.rc-subscription-details__button');
    
    if (tooltipSubsDetails) {
        tooltipSubsDetails.remove();
    }
    if (button) {
        const link = document.createElement('a');
        link.href = 'https://www.trestique.com/pages/auto-refill';
        link.classList.add(...button.classList);
        link.innerHTML = button.innerHTML;
        button.parentNode.replaceChild(link, button);
    }

    if (contentOtpSubs) {
        contentOtpSubs.classList.add("subs-otp-wrapper");
    }

    if (labelSubs) {
        const sbsContainerHead = document.createElement("div");
        sbsContainerHead.classList.add("sbs-container-head");
        const sbsContainerValueProps = document.createElement("div")
        sbsContainerValueProps.classList.add("sbs-value-props")

        const input = labelSubs.querySelector("input.rc-radio__input");
        const span = labelSubs.querySelector("span.rc-radio__label");
        const plans = widgetRecharge.querySelector(".rc-selling-plans");

        sbsContainerHead.appendChild(input);
        sbsContainerHead.appendChild(span);

        labelSubs.innerHTML = ""; 
        labelSubs.appendChild(sbsContainerHead);
        labelSubs.appendChild(sbsContainerValueProps);

        if (plans) {
            labelSubs.appendChild(plans);
        }
        addValueProps(sbsContainerValueProps);
    }

    if (sbsDiscountLabel) {
        sbsDiscountLabel.innerHTML = sbsDiscountLabel.innerHTML.replace('save 10%', 'Save 10% Now');
    }
    function addValueProps(sbsContainerValueProps) {
        subscriptionValueProps.forEach(function(block) {
            const valuePropItem = document.createElement('div');
            valuePropItem.classList.add('value-prop-item');

            if (block.image) {
                const img = document.createElement('img');
                img.src = block.image;
                img.alt = 'Image';
                img.style.width = '25px';
                valuePropItem.appendChild(img);
            }
    
            const text = document.createElement('p');
            text.textContent = block.valueProp;
            valuePropItem.appendChild(text);

            sbsContainerValueProps.appendChild(valuePropItem);
        });
    }
    
}   